import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { random, max } from 'lodash';
import CancelButton from '../../components/atoms/CancelButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import FileUpload from '../../components/molecules/FileUploadIdentity';
import ProgressDialog from '../../components/molecules/ProgressMobileDialog';
import { uploadFile, sendLogin } from '../../auth/Auth';
import { getGroupIdentities, editIdentityGroup } from '../../actions/Identity';
import { getShops } from '../../actions/Shop';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import AddMoreButton from '../../components/atoms/AddMoreButton';
import ValidationText from '../../components/atoms/ValidationText';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    }
  },
  inputLabel: {
    display: 'inline'
  },
  input: {
    display: 'none'
  },
  textField: {
    padding: '0px 5px 0px 5px'
  },
  bold: {
    fontWeight: 'bold'
  },
  colorBlack: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  underline: {
    textDecoration: 'underline'
  },
  indent_2: {
    marginLeft: '15px',
    display: 'block'
  },
  indent_4: {
    marginLeft: '30px',
    display: 'block'
  },
  mb10: {
    marginBottom: 10
  },
  divInPage: {
    padding: '20px 15px'
  },
  pt20: {
    paddingTop: 20
  },
  pt10: {
    paddingTop: 10
  },
  btnRequire: {
    paddingBottom: 10,
    paddingTop: 20
  },
  font16: {
    fontSize: 16,
    paddingTop: 10
  },
  font14: {
    fontSize: 14
  },
  font12: {
    fontSize: 12
  },
  font20: {
    fontSize: 20,
    paddingBottom: 0
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroupIdentities,
          editIdentityGroup,
          getShops
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openRegisterProgress', 'updateOpenRegisterProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isRegisterSuccess', 'updateIsRegisterSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),

  withState('numberSealCertificate', 'setNumberSealCertificate', 1),
  withState('numberBusinessLicense', 'setNumberBusinessLicense', 1),
  withState('numberRegisterCopy', 'setNumberRegisterCopy', 1),
  withState('sealCertificate', 'setSealCertificate', []),
  withState('businessLicense', 'setBusinessLicense', []),
  withState('registerCopy', 'setRegisterCopy', []),
  withState('previewImageSeal', 'setPreviewImageSeal', []),
  withState('previewImageLicense', 'setPreviewImageLicense', []),
  withState('previewImageRegisterCopy', 'setPreviewImageRegisterCopy', []),
  withState('companyCode', 'setCompanyCode', ''),
  withState('representativeName', 'setRepresentativeName', ''),
  withState('representativeNameKana', 'setRepresentativeNameKana', ''),
  withState('businessLicenseName', 'setBusinessLicenseName', []),
  withState('representativeNameErr', 'setRepresentativeNameErr', ''),
  withState('representativeNameKanaErr', 'setRepresentativeNameKanaErr', ''),
  withState('sealCertificateErr', 'setSealCertificateErr', ''),
  withState('businessLicenseErr', 'setBusinessLicenseErr', ''),
  withState('registerCopyErr', 'setRegisterCopyErr', ''),
  withState('sealCertificateType', 'setSealCertificateType', []),
  withState('businessLicenseType', 'setBusinessLicenseType', []),
  withState('registerCopyType', 'setRegisterCopyType', []),

  withState('titleMessage', 'setTitleMessage', ''),
  withState('btnText', 'setBtnText', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey = null,
    openRegisterProgress,
    updateOpenRegisterProgress,
    loading,
    updateLoading,
    isRegisterSuccess,
    updateIsRegisterSuccess,
    resultMessage,
    setResultMessage,

    sealCertificate,
    setSealCertificate,
    businessLicense,
    setBusinessLicense,
    registerCopy,
    setRegisterCopy,

    previewImageSeal,
    setPreviewImageSeal,
    previewImageLicense,
    setPreviewImageLicense,
    previewImageRegisterCopy,
    setPreviewImageRegisterCopy,
    updateOpenRegisterModal,
    targetRowId,
    reGetAccounts,
    titleMessage,
    setTitleMessage,
    btnText,
    setBtnText,
    companyCode,
    setCompanyCode,
    representativeName,
    setRepresentativeName,
    representativeNameKana,
    setRepresentativeNameKana,
    numberSealCertificate,
    setNumberSealCertificate,
    numberBusinessLicense,
    setNumberBusinessLicense,
    numberRegisterCopy,
    setNumberRegisterCopy,
    businessLicenseName,
    setBusinessLicenseName,
    representativeNameErr,
    setRepresentativeNameErr,
    representativeNameKanaErr,
    setRepresentativeNameKanaErr,
    sealCertificateErr,
    setSealCertificateErr,
    businessLicenseErr,
    setBusinessLicenseErr,
    registerCopyErr,
    setRegisterCopyErr,
    sealCertificateType,
    setSealCertificateType,
    businessLicenseType,
    setBusinessLicenseType,
    registerCopyType,
    setRegisterCopyType
  }) => {
    const cancelAction = () => updateOpenRegisterModal(false);

    const validRepresentativeNameKana = () => {
      const value = representativeNameKana ? representativeNameKana.trim() : '';
      if (value === '') {
        setRepresentativeNameKanaErr('必須項目です。');
        return 1;
      }
      if (!/^[\u3040-\u309F\s\d０-９ー]+$/.test(value)) {
        setRepresentativeNameKanaErr('ひらがなで入力してください。');
        return 1;
      }
      setRepresentativeNameKanaErr('');
      setRepresentativeNameKana(value);
      return 0;
    };

    const validRepresentativeName = () => {
      const value = representativeName ? representativeName.trim() : '';
      if (value === '') {
        setRepresentativeNameErr('必須項目です。');
        return 1;
      }
      setRepresentativeNameErr('');
      setRepresentativeName(value);
      return 0;
    };

    const validSealCertificate = () => {
      if (sealCertificate.length === 0) {
        setSealCertificateErr('必須項目です。');
        return 1;
      }
      setSealCertificateErr('');
      return 0;
    };

    const validRegisterCopy = () => {
      if (registerCopy.length === 0) {
        setRegisterCopyErr('必須項目です。');
        return 1;
      }
      setRegisterCopyErr('');
      return 0;
    };

    const validBusinessLicense = () => {
      if (businessLicense.length !== businessLicenseName.length) {
        setBusinessLicenseErr('書類名称と画像を同時にお願いします。');
        return 1;
      }
      setBusinessLicenseErr('');
      return 0;
    };

    const valid = () => {
      const errorCount =
        validSealCertificate() +
        validRegisterCopy() +
        validBusinessLicense() +
        validRepresentativeNameKana() +
        validRepresentativeName();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const registAction = async () => {
      if (valid()) {
        updateLoading(true);
        updateOpenRegisterProgress(true);
        let sealPath = [];
        let licensePath = [];
        let registerCopyPath = [];
        if (sealCertificate.length > 0) {
          const imagePaths = await Promise.all(
            sealCertificate.map(async image => {
              if (image) {
                // if (image.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
                //   const { resizeImageFile } = await resizeImage(image);
                //   image = resizeImageFile;
                // }
                const imagePath = await uploadFile(
                  'identity',
                  targetRowId,
                  image,
                  'public'
                );
                return imagePath;
              }
              return null;
            })
          );
          sealPath = imagePaths
            .filter(i => i !== null)
            .map((i, index) => {
              return { image: i, viewOrder: index };
            });
        }
        if (businessLicense.length > 0) {
          const imagePaths = await Promise.all(
            businessLicense.map(async image => {
              if (image) {
                const imagePath = await uploadFile(
                  'identity',
                  targetRowId,
                  image,
                  'public'
                );
                return imagePath;
              }
              return null;
            })
          );
          licensePath = imagePaths
            .filter(i => i !== null)
            .map((i, index) => {
              return { image: i, viewOrder: index };
            });
        }
        if (registerCopy.length > 0) {
          const imagePaths = await Promise.all(
            registerCopy.map(async image => {
              if (image) {
                const imagePath = await uploadFile(
                  'identity',
                  targetRowId,
                  image,
                  'public'
                );
                return imagePath;
              }
              return null;
            })
          );
          registerCopyPath = imagePaths
            .filter(i => i !== null)
            .map((i, index) => {
              return { image: i, viewOrder: index };
            });
        }

        const identityImages = [];
        const maxLengthImage = max([
          sealCertificate.length,
          businessLicense.length,
          registerCopy.length
        ]);
        if (maxLengthImage) {
          for (let i = 0; i < maxLengthImage; i += 1) {
            identityImages.push({
              sealCertificate: sealPath[i] ? sealPath[i].image : '',
              registeredCopy: registerCopyPath[i]
                ? registerCopyPath[i].image
                : '',
              other: licensePath[i] ? licensePath[i].image : '',
              note:
                licensePath[i] && businessLicenseName[licensePath[i].viewOrder]
                  ? businessLicenseName[licensePath[i].viewOrder]
                  : ''
            });
          }
        }

        const editedIdentity = await actions
          .editIdentityGroup(targetRowId, {
            companyCode,
            representativeName,
            representativeNameKana,
            identityImages
          })
          .then(data => checkSession(data));
        if (editedIdentity.type === 'EDIT_IDENTITY_GROUP_SUCCESS') {
          updateIsRegisterSuccess(true);
          if (!searchKey) {
            // グループ情報管理からの登録の場合
            await actions.getShops().then(data => checkSession(data));
          }
          setResultMessage('本人確認書類の登録が完了しました。');
          setTitleMessage('本人確認書類送信完了');
          setBtnText('OK');
          updateLoading(false);
        } else {
          updateIsRegisterSuccess(false);
          setResultMessage('登録に失敗しました。');
          updateLoading(false);
        }
      } else {
        alert('本人確認資料を登録してください。');
      }
    };

    const progressOkAction = async () => {
      if (isRegisterSuccess) {
        updateOpenRegisterModal(false);
        updateOpenRegisterProgress(false);
        // 本人確認書類検索からの登録の場合
        await actions
          .getGroupIdentities(searchKey)
          .then(data => checkSession(data));
        if (reGetAccounts && typeof reGetAccounts === 'function') {
          reGetAccounts();
        }
      } else {
        updateOpenRegisterProgress(false);
      }
    };

    const handleSetRegisterCopy = (value, index) => {
      const tmpValue = [...registerCopy];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setRegisterCopy([...tmpValue]);
    };

    const handleSetRegisterCopyType = (value, index) => {
      const tmpValue = [...registerCopyType];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setRegisterCopyType([...tmpValue]);
    };

    const handleSetPreviewImageRegisterCopy = (value, index) => {
      const tmpValue = [...previewImageRegisterCopy];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setPreviewImageRegisterCopy([...tmpValue]);
    };

    const getRegisterCopyButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberRegisterCopy; i += 1) {
        arrButton.push(
          <FileUpload
            key={random(true)}
            label={`registerCopy-${i}`}
            setFile={handleSetRegisterCopy}
            previewImage={previewImageRegisterCopy[i]}
            setPreviewImage={handleSetPreviewImageRegisterCopy}
            indexNumber={i}
            setType={handleSetRegisterCopyType}
            type={registerCopyType[i]}
            largePreview
          />
        );
      }
      return arrButton;
    };

    const handleSetSealCertificate = (value, index) => {
      const tmpValue = [...sealCertificate];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setSealCertificate([...tmpValue]);
    };

    const handleSetSealCertificateType = (value, index) => {
      const tmpValue = [...sealCertificateType];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setSealCertificateType([...tmpValue]);
    };

    const handleSetPreviewImageSeal = (value, index) => {
      const tmpValue = [...previewImageSeal];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setPreviewImageSeal([...tmpValue]);
    };

    const getSealCertificateButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberSealCertificate; i += 1) {
        arrButton.push(
          <FileUpload
            key={random(true)}
            label={`seal-${i}`}
            setFile={handleSetSealCertificate}
            previewImage={previewImageSeal[i]}
            setPreviewImage={handleSetPreviewImageSeal}
            indexNumber={i}
            setType={handleSetSealCertificateType}
            type={sealCertificateType[i]}
            largePreview
          />
        );
      }
      return arrButton;
    };

    const handleSetBusinessLicense = (value, index) => {
      const tmpValue = [...businessLicense];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setBusinessLicense([...tmpValue]);
    };

    const handleSetBusinessLicenseType = (value, index) => {
      const tmpValue = [...businessLicenseType];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setBusinessLicenseType([...tmpValue]);
    };

    const handleSetPreviewImageLicense = (value, index) => {
      const tmpValue = [...previewImageLicense];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setPreviewImageLicense([...tmpValue]);
    };

    const handleSetBusinessLicenseName = (value, index) => {
      const tmpValueName = [...businessLicenseName];
      tmpValueName[index] = value;
      setBusinessLicenseName([...tmpValueName]);
    };

    const getBusinessLicenseButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberBusinessLicense; i += 1) {
        arrButton.push(
          <div key={random(true)}>
            <TextField
              label="詳細"
              fullWidth
              className={classes.textField}
              margin="normal"
              defaultValue={
                businessLicenseName[i] ? businessLicenseName[i] : ''
              }
              onBlur={e => {
                handleSetBusinessLicenseName(e.target.value, i);
              }}
            />
            <FileUpload
              label={`license-${i}`}
              setFile={handleSetBusinessLicense}
              previewImage={previewImageLicense[i]}
              setPreviewImage={handleSetPreviewImageLicense}
              indexNumber={i}
              setType={handleSetBusinessLicenseType}
              type={businessLicenseType[i]}
              largePreview
            />
          </div>
        );
      }
      return arrButton;
    };

    return (
      <div className={classes.root}>
        <div className={classes.divInPage}>
          <Typography
            variant="h6"
            className={classNames(classes.font20, classes.bold)}
          >
            グループ確認書類登録
          </Typography>
          <Typography color="textPrimary" className={classes.font14}>
            グループ登録には審査がございます。
            <br />
            以下の審査に必要となる書類のご提出をお願いいたします。
            <br />
            <span className={classes.font12}>
              ※
              画像ファイルはスマートフォン撮影のデータやスキャンデータでも可能です。
            </span>
          </Typography>
        </div>
        <Divider />
        <div className={classes.divInPage}>
          <div>
            <Typography
              variant="h6"
              color="textSecondary"
              className={classNames(classes.font20, classes.bold)}
            >
              必要資料の添付
            </Typography>
          </div>
          <div className={classes.btnRequire}>
            <RequiredButton />
          </div>
          <div className={classes.pt10}>
            <Typography variant="p" color="textPrimary">
              <span
                className={classNames(
                  classes.bold,
                  classes.colorBlack,
                  classes.font16
                )}
              >
                ① 登記簿謄本
              </span>
              <br />
              <span className={classes.font12}>
                必ず取得して1年以内のものを添付してください。
                <br />
                (ファイル形式：jpg,png,pdf)
              </span>
            </Typography>
            {getRegisterCopyButtons()}
            <AddMoreButton
              disabled={numberRegisterCopy >= 5}
              onClickAction={() =>
                setNumberRegisterCopy(numberRegisterCopy + 1)
              }
            />
            <ValidationText message={registerCopyErr} />
          </div>
          <div className={classes.btnRequire}>
            <RequiredButton />
          </div>
          <div className={classes.pt10}>
            <Typography variant="p" color="textPrimary">
              <span
                className={classNames(
                  classes.bold,
                  classes.colorBlack,
                  classes.font16
                )}
              >
                ② 印鑑証明
              </span>
              <br />
              <span className={classes.font12}>
                必ず取得して1年以内のものを添付してください。
                <br />
                (ファイル形式：jpg,png,pdf)
                <br />
                ※①の登記簿謄本と同じ法人のものに限る
              </span>
            </Typography>
            {getSealCertificateButtons()}
            <AddMoreButton
              disabled={numberSealCertificate >= 5}
              onClickAction={() =>
                setNumberSealCertificate(numberSealCertificate + 1)
              }
            />
            <ValidationText message={sealCertificateErr} />
          </div>
        </div>
        <Divider />
        <div className={classes.divInPage}>
          <div>
            <Typography
              variant="h6"
              color="textSecondary"
              className={classNames(classes.font20, classes.bold)}
            >
              その他資料の添付
            </Typography>
          </div>
          <div className={classes.btnRequire}>
            <AnyButton />
          </div>
          <div className={classes.pt10}>
            <Typography
              variant="p"
              color="textPrimary"
              className={classes.font12}
            >
              住所変更や企業名変更・企業統合で登記簿と印鑑証明で異なる場合は詳細記載の上、内容証明できる資料を添付してください。
            </Typography>
            {getBusinessLicenseButtons()}
            <AddMoreButton
              disabled={numberBusinessLicense >= 5}
              onClickAction={() =>
                setNumberBusinessLicense(numberBusinessLicense + 1)
              }
            />
            <ValidationText message={businessLicenseErr} />
          </div>
        </div>
        <Divider />
        <div className={classes.divInPage}>
          <div className={classes.btnRequire}>
            <AnyButton />
          </div>
          <div>
            <TextField
              label="法人番号"
              type="number"
              placeholder="0123456789012"
              fullWidth
              className={classes.textField}
              margin="normal"
              value={companyCode}
              onChange={e => {
                setCompanyCode(e.target.value);
              }}
            />
          </div>
        </div>
        <Divider />
        <div className={classes.divInPage}>
          <div className={classes.btnRequire}>
            <RequiredButton />
          </div>
          <div>
            <TextField
              required
              label="代表者名"
              fullWidth
              className={classes.textField}
              margin="normal"
              value={representativeName}
              onChange={e => {
                setRepresentativeName(e.target.value);
              }}
              onBlur={validRepresentativeName}
            />
            <ValidationText message={representativeNameErr} />
          </div>
        </div>
        <Divider />
        <div className={classes.divInPage}>
          <div className={classes.btnRequire}>
            <RequiredButton />
          </div>
          <div>
            <TextField
              required
              label="代表者名かな"
              fullWidth
              className={classes.textField}
              margin="normal"
              value={representativeNameKana}
              onChange={e => {
                setRepresentativeNameKana(e.target.value);
              }}
              onBlur={validRepresentativeNameKana}
            />
            <ValidationText message={representativeNameKanaErr} />
          </div>
        </div>
        <Divider />
        <div className={classes.divInPage}>
          <Typography variant="p" color="textPrimary">
            注意点
            <br />
            ご購入者様の支払い方法としてPayPay決済もご用意しておりますが、法人の場合は管理システムへの反映に２週間〜１ヶ月ほどかかる場合がございます。
            <br />
            店舗の審査基準
            <br />
            グループ機能を利用して店舗をご登録頂く場合でも、個別の店舗登録と同様に各店舗の審査がございます。下記の通りの審査基準となっておりますのでご了承ください。
            <br />
            ・店舗の存在が確認でき、その本人（または責任者・社員）が登録していると判断できる事。
            <br />
            ・風営法の、風俗営業1号営業〜4号営業、性風俗関連特殊営業、を行っていない事。
          </Typography>
        </div>
        <div className={classes.divInPage}>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <RegisterButton
            onClickAction={registAction}
            disabled={
              !(
                sealCertificate.length > 0 &&
                registerCopy.length > 0 &&
                representativeName &&
                representativeNameKana
              )
            }
          />
        </div>
        <ProgressDialog
          openProgress={openRegisterProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
          title={titleMessage}
          btnText={btnText}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
